module.exports = __webpack_public_path__ + "img/1521148077.aac8280b.jpg";